import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteContactMutationAtom = createMutationAtomFactory(
  'crm.contactDelete',
  ({ id }: { id: string }) => ({
    crmContactDelete: {
      __args: {
        id,
      },
    },
  }),
);
